import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SideMenuLeftComponent } from './side-menu-left.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    SideMenuLeftComponent,
  ],
  exports: [
    SideMenuLeftComponent
  ]
})
export class SideMenuLeftModule {
}
